import React from 'react'
import { DataHandler, DateTimeHandler } from 'utils'


const TITLES = { 'day': '最近訊息',  'week': '市場觀點',  'month': '趨勢報告' };
const DaySwitchComponent = ({ dayType, data, onClick }) => {
  let types = data
    .sort((a, b) => (a - b))
    .map((days) => (DateTimeHandler.getDayType(days)));
  types = DataHandler.duplicatesRemover(types);

  const component = types.map((type, idx) => (
    <button
      type='button'
      className={`ua-btn-tab ${(dayType === type) ? 'active' : ''}`}
      data-daytype={type}
      disabled={dayType === type}
      onClick={onClick}
      key={idx}
    >
      {TITLES[type]}
    </button>
  ));

  return ((component.length > 0)
    ?
    <div className='w-100 margin-bottom-20'>
      <div className='module-tool'>
        {component}
      </div>
    </div>
    :
    null
  );
}


export { DaySwitchComponent }
